import { useEffect, useState } from 'react';
import { Chip } from '@mui/material';
import { onlyShortMonth, onlyYear } from '../../../functions/nextSessionFormat';
import { colors } from '../../../styles/globalStyles';
import { selectedLanguageAtom } from '../../../recoil/atoms/languageAtom';
import { useRecoilValue } from 'recoil';

const TimeLineChip = ({ isVisible }) => {
    const selectedLanguage = useRecoilValue(selectedLanguageAtom);

    const todayDate = new Date().toISOString().slice(0, 10);
    const [activeMonth, setActiveMonth] = useState(onlyShortMonth(todayDate, selectedLanguage));
    const [activeYear, setActiveYear] = useState(onlyYear(todayDate));

    useEffect(() => {
        if (isVisible?.target) {
            setActiveMonth(onlyShortMonth(isVisible.target.id, selectedLanguage));
            setActiveYear(onlyYear(isVisible.target.id));
        }
    }, [isVisible, selectedLanguage]);

    return (
        <Chip
            label={`${activeMonth}, ${activeYear}`}
            variant={'lightBlue'}
            size={'small'}
            sx={{ color: colors.darkBlue }}
        />
    );
};

export default TimeLineChip;
